// extracted by mini-css-extract-plugin
export default {"container":"BrandLogo_container__se1tw","large":"BrandLogo_large__V0yLp"};